<div class="py-2">
  <!-- Conditional Question: Do you have extra income? -->
  <div class="signio-divider-header">
    <label class="signio-divider-header-title">Income Details</label>
  </div>
  
  <div class="conditional-question-section mt-3 mb-4">
    <label class="form-label fw-semibold mb-2">
      Do you have any additional sources of income besides your main salary?
    </label>
    <p class="text-muted small mb-3">
      This includes income from bonuses, commissions, investments, rentals, pension, or any other sources.
    </p>
    <div class="d-flex gap-4">
      <div class="form-check">
        <input 
          class="form-check-input" 
          type="radio" 
          name="hasExtraIncome" 
          id="hasExtraIncomeYes" 
          :value="true" 
          v-model="has_extra_income"
        />
        <label class="form-check-label" for="hasExtraIncomeYes">
          Yes, I have extra income
        </label>
      </div>
      <div class="form-check">
        <input 
          class="form-check-input" 
          type="radio" 
          name="hasExtraIncome" 
          id="hasExtraIncomeNo" 
          :value="false" 
          v-model="has_extra_income"
        />
        <label class="form-check-label" for="hasExtraIncomeNo">
          No, I do not have extra income
        </label>
      </div>
    </div>
  </div>

  <!-- Conditional Content: Income Details (only shown when has_extra_income is true) -->
  <transition name="fade">
    <div v-if="show_income_details" class="mt-3">
      <div
        class="signio-divider-header"
        @click="toggle('income_amounts')"
      >
        <span class="chevron"
          >{{ collapsed_sections.income_amounts ? '▸' : '▾' }}</span
        >
        <label class="signio-divider-header-title">Income Amounts</label>
      </div>
      <transition name="fade">
        <div v-show="!collapsed_sections.income_amounts">
          <div class="row g-3">
            <div
              v-for="field in amount_fields"
              :key="field.boolean_key"
              class="col-md-4 mb-3"
            >
              <label class="form-label text-xs mb-1">{{ field.short_label }}</label>
              <div class="mt-1">
                <div class="currency-input-group" tabindex="-1">
                  <span class="currency-prefix">R</span>
                  <input
                    type="number"
                    class="currency-input"
                    :id="field.amount_key"
                    v-model="form_data[field.amount_key]"
                    @input="on_amount_input(field)"
                    @blur="format_amount(field)"
                    placeholder="0.00"
                    inputmode="decimal"
                    step="0.01"
                    min="0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <div
        class="signio-divider-header mt-4"
        @click="toggle('income_options')"
      >
        <span class="chevron"
          >{{ collapsed_sections.income_options ? '▸' : '▾' }}</span
        >
        <label class="signio-divider-header-title">Income Options</label>
      </div>
      <transition name="fade">
        <div v-show="!collapsed_sections.income_options">
          <div class="row mt-3">
            <div
              v-for="field in boolean_fields"
              :key="field.boolean_key"
              class="col-sm-12 mb-2"
            >
              <label class="form-label text-xs mb-1"
                >{{ field.boolean_label }}</label
              >
              <select
                class="form-select"
                :id="field.boolean_key"
                v-model="form_data[field.boolean_key]"
              >
                <option v-if="form_data[field.boolean_key] == ''" selected :value="null">Not Selected</option>
                <option v-else :value="null">Not Selected</option>
                <option :value="true">Yes</option>
                <option :value="false">No</option>
              </select>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>

  <!-- Message when user selects "No extra income" -->
  <transition name="fade">
    <div v-if="has_extra_income === false" class="alert alert-info border-0 mt-3 py-2 px-3">
      You have indicated that you do not have any additional income sources. Click "Continue" to proceed to the next step.
    </div>
  </transition>

  <!-- Add submit button -->
  <div class="text-end mt-4">
    <button type="button" @click="previous" class="btn btn-bg-secondary text-xs rounded-small shadow-sm me-1">
      Previous
    </button>
    <button
      type="button"
      @click="submit_section"
      class="btn btn-bg-green text-xs rounded-small shadow-sm"
      :disabled="has_extra_income === null"
    >
      Continue
    </button>
  </div>
</div>
